'use client'
import { useTranslations } from 'next-intl'
import React from 'react'

import '@pearlconvert/ui/components/preloader/styles/preloader.scss'

const Preloader: React.FC = () => {
  const t = useTranslations('ui')
  return (
    <span
      className="preloader"
      aria-hidden="true"
      aria-label={t('_globals.loading')}
      aria-live="polite"
      role="status"
    />
  )
}

export default Preloader
